import { unity, stores, funcional, area, cdType } from '../../modules/select';
import { recaptchaUpdater } from '../../modules/recaptcha';

export const profilesRede = () => {
  unity();
  stores();
  funcional();
  area();
  cdType();
  recaptchaUpdater('profile');
};
